import { buildSocketUrl } from './conf'
import { Toast } from 'services'
import { i18n } from 'i18n'
import _ from 'lodash'

/*
 * Shared code for sockets used for communicating directly with Manatee
 */

function handleSocketEvents(ws, isClosedFn, event) {
  ws.onopen = () => {
    console.log('On open')
    event.emit('open', {})
  }
  ws.onclose = msg => {
    if (isClosedFn && isClosedFn()) return
    console.log('Manatee socket closed', msg)
    const toastMsg = msg.code === 1015 ? 'MANATEE_CERTIFICATE_EXPIRED' : 'NO_MANATEE_CONNECTION'
    Toast.warning(i18n.t('CONNECTION_FAILED'), {
      remove: 5000,
      text: i18n.t(toastMsg, { code: msg.code ? ` (${msg.code})` : '' })
    })
    event.emit('close', msg)
  }

  ws.onerror = msg => console.error('socket error', msg)
}

function createWebsocketBackedSocket(endpoint, host, port, securePort) {
  const wsUrl = buildSocketUrl(endpoint, host, port, securePort)
  console.log(`Creating websocket backed ${endpoint} socket`, wsUrl)
  return new WebSocket(wsUrl)
}

function createMessageBackedSocket(endpoint) {
  const ws = {
    onmessage: null,
    send(msg) {
      window.postMessage({ payload: msg, endpoint, type: 'pageToManatee' })
    },
    close(noEvent) {
      // Get steller to close the backing websocket
      window.postMessage({ endpoint, type: 'pageToManatee', control: 'close' })
      window.removeEventListener('message', handleMessage)
      if (!noEvent && ws.onclose) {
        ws.onclose({})
      }
    }
  }

  function handleMessage(evt) {
    const msg = evt.data
    if (!msg || msg.type !== 'toPage') return
    if (!msg.endpoint && msg.payload === 'puppeteer-pong' && ws.onopen) {
      ws.onopen()
      return
    }
    if (msg.control === 'onClose' && ws.onclose) ws.onclose({})
    if (ws.onmessage) ws.onmessage(evt.data && { data: evt.data.payload })
  }
  // Listen for messages from puppeteer
  window.addEventListener('message', handleMessage)
  // Check that puppeteer is ready to talk
  window.postMessage({ payload: 'puppeteer-ping', type: 'pageToManatee' })

  return ws
}

// This function handles fallback to websocket if steller isn't responding
export function connectManateeSocket(
  endpoint,
  updateWsFn,
  event,
  host,
  port,
  securePort,
  isClosedFn
) {
  // First try extension powered message passing websocket proxy
  let activeWs = updateWsFn(createMessageBackedSocket(endpoint))
  let connectState = 'AWAITING_PROXY'

  const delayedErrorHandler = _.debounce(() => {
    switch (connectState) {
      case 'AWAITING_PROXY': // No support for proxied communications - fall back to ws
        activeWs.close(true)
        console.log('Handshake via ws-proxy failed. Is the sirenia browser extension installed?')
        activeWs = updateWsFn(createWebsocketBackedSocket(endpoint, host, port, securePort))
        connectState = 'AWAITING_WS'
        // The ws.onerror is unpredictable, so we assume error if connecting takes over one second
        delayedErrorHandler()
        handleSocketEvents(activeWs, isClosedFn, event)
        break
      case 'AWAITING_WS':
        activeWs.close()
        break
    }
  }, 1000)
  event.on('open', () => delayedErrorHandler.cancel())
  event.on('close', () => delayedErrorHandler.cancel())
  handleSocketEvents(activeWs, isClosedFn, event)
  delayedErrorHandler()
}
